import React from 'react';
import { capitalizarModalidad } from './logica';

const fechaCorta = (iso) => String(iso).slice(0, 10).split('-').reverse().join('/');

// Aplazados con justificante aprobado por el comité que vienen de la jornada
// anterior (se arrastran visualmente a esta en /jornadas). Los de la propia
// jornada no se listan aquí: ya están en su cuadrante. Solo lectura: se reprograman desde /dashboard/revisar-aplazamiento.
// `calendario` son los partidos tal cual los devuelve /calendario-detalle.
export const aplazadosJustificados = (calendario, jornada) =>
  calendario
    .filter((p) => p.aplazado_justificado && p.jornada === jornada - 1)
    .sort((a, b) => a.jornada - b.jornada || a.modalidad.localeCompare(b.modalidad));

// Incidencias en las que el partido no llega a jugarse (incomparecencia, lesión, sanción...).
// INTERRUMPIDO no está: ese sí se jugó, hasta el límite de tiempo.
const INCIDENCIAS_SIN_JUEGO = [
  'WO_INCOMPARECENCIA', 'WO_FUERA_DE_PLAZO', 'SIN_AVISO', 'WO_LESION', 'WO_SANCION', 'NO_DISPUTADO',
];
export const esWo = (p) => INCIDENCIAS_SIN_JUEGO.includes(p.incidencia);

// Aplazados (con o sin justificante) y partidos con WO de la propia jornada: no se
// juegan en su fecha, así que no deben ocupar pista. `calendario` es /calendario-detalle.
export const aplazadosDeJornada = (calendario, jornada) =>
  calendario
    .filter((p) => (p.estado === 'APLAZADO' || esWo(p)) && p.jornada === jornada)
    .sort((a, b) => a.modalidad.localeCompare(b.modalidad) || a.id - b.id);

// `propios` son los aplazados y WO de esta jornada; `colocados` mapea partidoId ->
// { pista, franjaId } si siguen en el cuadrante; `onSacar` (solo ADMIN) los libera.
export const AplazadosDeJornada = ({ propios, colocados, onSacar, procesando }) => {
  if (propios.length === 0) return null;
  return (
    <section className="cp-aplazados" aria-labelledby="cp-aplazados-propios-titulo">
      <h4 id="cp-aplazados-propios-titulo">Partidos aplazados o con WO de esta jornada ({propios.length})</h4>
      <ul className="cp-aplazados-lista">
        {propios.map((p) => {
          const ubicacion = colocados[p.id];
          return (
            <li key={p.id} className="cp-aplazado">
              <span className="cp-aplazado-modalidad">{capitalizarModalidad(p.modalidad)}</span>
              <span className="cp-aplazado-partido">
                {p.local_nombre} <span className="cp-aplazado-vs">vs</span> {p.visitante_nombre}
              </span>
              <span className="cp-aplazado-etiquetas">
                {esWo(p) && <span className="etiqueta-wo">WO</span>}
                {p.aplazado_justificado && (p.fecha_reprogramada
                  ? <span className="cp-aplazado-fecha">nueva fecha {fechaCorta(p.fecha_reprogramada)}</span>
                  : <span className="etiqueta-pendiente-reprogramacion">pendiente reprogramación</span>)}
                {ubicacion && <span className="cp-aplazado-fecha">en pista {ubicacion.pista} a las {ubicacion.franjaId}</span>}
                {ubicacion && onSacar && (
                  <button type="button" className="btn btn-danger cp-sacar" onClick={() => onSacar(p.id)} disabled={procesando}>
                    Sacar del cuadrante
                  </button>
                )}
              </span>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

const AplazadosJustificados = ({ partidos }) => {
  if (partidos.length === 0) return null;
  return (
    <section className="cp-aplazados" aria-labelledby="cp-aplazados-titulo">
      <h4 id="cp-aplazados-titulo">Partidos aplazados y justificados ({partidos.length})</h4>
      <ul className="cp-aplazados-lista">
        {partidos.map((p) => (
          <li key={p.id} className="cp-aplazado">
            <span className="cp-aplazado-modalidad">{capitalizarModalidad(p.modalidad)} · jornada {p.jornada}</span>
            <span className="cp-aplazado-partido">
              {p.local_nombre} <span className="cp-aplazado-vs">vs</span> {p.visitante_nombre}
            </span>
            <span className="cp-aplazado-etiquetas">
              {p.fecha_reprogramada
                ? <span className="cp-aplazado-fecha">nueva fecha {fechaCorta(p.fecha_reprogramada)}</span>
                : <span className="etiqueta-pendiente-reprogramacion">pendiente reprogramación</span>}
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default AplazadosJustificados;
